module.exports = __webpack_public_path__ + "media/AG-Virtual.2d138dae.mp4";